<template>
  <div id="modalNotaFiscalOpcoes">
    <q-dialog v-model="openDialogOpcoesNotaFiscal" persistent>
      <q-card style="width: 1250px; max-width: 95vw;">
        <q-card-section class="row items-center">
          <div class="text-h6">Nota Fiscal</div>
          <q-space />
          <q-btn
            class="q-ml-lg"
            icon="close"
            flat
            round
            dense
            @click="cancela()"
          />
        </q-card-section>

        <q-separator />

        <q-card-section class="scroll" style="max-height: 70vh">
          <div class="row q-col-gutter-lg">

            <div class="col-12 col-md-8">
              <div class="row q-col-gutter-md">
                <div class="col-6 col-sm-4 col-md-4">
                  <q-input
                    label="Último Lote"
                    v-model="opcoes.notasfiscais_ultimolote"
                    :class="{ 'field-dirty': isDirty('notasfiscais_ultimolote') }"
                  />
                </div>
                <div class="col-6 col-sm-4 col-md-4">
                  <q-input
                    label="Última Referência"
                    v-model="opcoes.notasfiscais_ultimorps"
                    :class="{ 'field-dirty': isDirty('notasfiscais_ultimorps') }"
                  />
                </div>
                <div class="col-12 col-sm-4 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_regimeespecialtributacao"
                    label="Regime Especial de Tributação"
                    :options="opcoesRegimeEspecialTributacaoAbrasf"
                    emit-value
                    map-options
                    :error="errors.notasfiscais_regimeespecialtributacao ? true : false"
                    :disable="opcoes.notasfiscais_habilitar_nfsen == 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_regimeespecialtributacao') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen == 1">
                      Substituído por "Regime Especial de Tributação (NFSe Nacional)" quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errors.notasfiscais_regimeespecialtributacao"
                        :key="error + i"
                      >
                        {{ error }}
                      </span>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-sm-4 col-md-4">
                  <q-input
                    label="Alíquota"
                    :model-value="opcoes.notasfiscais_aliquota"
                    @update:model-value="val => onPercentualInput('notasfiscais_aliquota', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :class="{ 'field-dirty': isDirty('notasfiscais_aliquota') }"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Item da Lista de Serviço"
                    v-model="opcoes.notasfiscais_itemlistaservico"
                    :disable="opcoes.notasfiscais_habilitar_nfsen == 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_itemlistaservico') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen == 1">
                      Substituído por "Código de tributação nacional ISS" quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Descrição do Item da Lista de Serviço"
                    v-model="opcoes.notasfiscais_descricaoitemlistaservico"
                    :class="{ 'field-dirty': isDirty('notasfiscais_descricaoitemlistaservico') }"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código CNAE"
                    v-model="opcoes.notasfiscais_codigocnae"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigocnae') }"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Inscrição Municipal"
                    v-model="opcoes.notasfiscais_inscricaomunicipal"
                    :error="errors.notasfiscais_inscricaomunicipal ? true : false"
                    :class="{ 'field-dirty': isDirty('notasfiscais_inscricaomunicipal') }"
                  >
                    <template v-slot:error>
                      <span
                        v-for="(error, i) in errors.notasfiscais_inscricaomunicipal"
                        :key="error + i"
                      >
                        {{ error }}
                      </span>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código do Município"
                    v-model="opcoes.notasfiscais_codigomunicipio"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigomunicipio') }"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código de Tributação do Município"
                    v-model="opcoes.notasfiscais_codigotributacaomunicipio"
                    :disable="opcoes.notasfiscais_habilitar_nfsen == 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigotributacaomunicipio') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen == 1">
                      Substituído por "Código de tributação municipal ISS" quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_optantesimplesnacional"
                    label="Optante Simples Nacional"
                    :options="opcoesSimNao"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_optantesimplesnacional') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen == 1">
                      Também usado na NFSe Nacional: controla se "Regime Tributário Simples Nacional" é enviado.
                    </q-tooltip>
                  </q-select>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_incentivadorcultural"
                    label="Incentivador Cultural"
                    :options="opcoesSimNao"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_incentivadorcultural') }"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_homologacao"
                    label="Ambiente"
                    :options="opcoesAmbiente"
                    option-value.value="notasfiscais_homologacao"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_homologacao') }"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_gerar_nfse"
                    label="Gerar nota quando:"
                    :options="opcoesGerarNota"
                    option-value.value="notasfiscais_gerar_nfse"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_gerar_nfse') }"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="NBS"
                    v-model="opcoes.notasfiscais_codigo_nbs_nfsen"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigo_nbs_nfsen') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Obrigatório em municípios com layout de NFSe Nacional (ex: Fortaleza-CE). Deixe em branco se não for exigido pela sua prefeitura.
                          Veja o link "Anexo B – NBS2 / Lista Nacional" em Links Úteis, abaixo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código Indicador de Operação"
                    v-model="opcoes.notasfiscais_codigo_indicador_operacao"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigo_indicador_operacao') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Obrigatório em municípios com layout de NFSe Nacional (ex: Fortaleza-CE) — rejeição E638 quando ausente nesses casos.
                          Veja o link "Tabela de Indicadores da Operação" em Links Úteis, abaixo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="CST IBS/CBS"
                    v-model="opcoes.notasfiscais_ibs_cbs_situacao_tributaria"
                    :class="{ 'field-dirty': isDirty('notasfiscais_ibs_cbs_situacao_tributaria') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Formato exemplo: "000". Obrigatório em municípios com layout de NFSe Nacional (ex: Fortaleza-CE) — rejeição E638 quando ausente nesses casos.
                          Veja o link "Classificação Tributária (CST / cClassTrib)" em Links Úteis, abaixo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Classificação Tributária IBS/CBS"
                    v-model="opcoes.notasfiscais_ibs_cbs_classificacao_tributaria"
                    :class="{ 'field-dirty': isDirty('notasfiscais_ibs_cbs_classificacao_tributaria') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Formato exemplo: "000001". Obrigatório em municípios com layout de NFSe Nacional (ex: Fortaleza-CE) — rejeição E638 quando ausente nesses casos.
                          Veja o link "Classificação Tributária (CST / cClassTrib)" em Links Úteis, abaixo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_finalidade_emissao"
                    label="Finalidade de Emissão"
                    :options="opcoesFinalidadeEmissao"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_finalidade_emissao') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Indica a finalidade da emissão da nota. Hoje só existe a opção "NFS-e Regular" documentada para esse campo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_indicador_destinatario"
                    label="Indicador Destinatário"
                    :options="opcoesIndicadorDestinatario"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_indicador_destinatario') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Indica se quem efetivamente recebe o serviço é o próprio tomador da nota, ou se é uma outra pessoa/empresa diferente do tomador.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_consumidor_final"
                    label="Consumidor Final"
                    :options="opcoesConsumidorFinalReforma"
                    emit-value
                    map-options
                    :class="{ 'field-dirty': isDirty('notasfiscais_consumidor_final') }"
                  >
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Indica se o tomador é o consumidor final do serviço (não vai revender/repassar) ou se está adquirindo para uso em outra etapa da cadeia.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>
              </div>

              <q-separator class="q-my-md" />

              <div class="row q-col-gutter-md">
                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen"
                    label="Opção Simples Nacional"
                    :options="opcoesCodigoOpcaoSimplesNacionalNfsen"
                    emit-value
                    map-options
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigo_opcao_simples_nacional_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_regime_especial_tributacao_nfsen"
                    label="Regime Especial de Tributação (NFSe Nacional)"
                    :options="opcoesRegimeEspecialTributacaoNfsen"
                    emit-value
                    map-options
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_regime_especial_tributacao_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_regime_tributario_simples_nacional_nfsen"
                    label="Regime Tributário Simples Nacional"
                    :options="opcoesRegimeTributarioSimplesNacionalNfsen"
                    emit-value
                    map-options
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_regime_tributario_simples_nacional_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Preencha apenas se a empresa for optante pelo Simples Nacional (campo "Opção Simples Nacional" diferente de "Não Optante").
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código de tributação municipal ISS"
                    v-model="opcoes.notasfiscais_codigo_tributacao_municipal_iss_nfsen"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigo_tributacao_municipal_iss_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Código de 3 dígitos definido pela própria prefeitura — não existe uma lista nacional única, consulte o padrão do seu município (para algumas prefeituras pode ser opcional).
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Código de tributação nacional ISS"
                    v-model="opcoes.notasfiscais_codigo_tributacao_nacional_iss_nfsen"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_codigo_tributacao_nacional_iss_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          O formato é diferente do código antigo do Abrasf.
                          Veja o link "Anexo B – NBS2 / Lista Nacional" em Links Úteis, abaixo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_tipo_retencao_iss_nfsen"
                    label="Tipo de Retenção ISS"
                    :options="opcoesTipoRetencaoIssNfsen"
                    emit-value
                    map-options
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_tipo_retencao_iss_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-select
                    v-model="opcoes.notasfiscais_tributacao_iss_nfsen"
                    label="Tributação ISS"
                    :options="opcoesTributacaoIssNfsen"
                    emit-value
                    map-options
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_tributacao_iss_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Percentual de partilha do ISS"
                    :model-value="opcoes.notasfiscais_percentual_aliquota_relativa_municipio_nfsen"
                    @update:model-value="val => onPercentualInput('notasfiscais_percentual_aliquota_relativa_municipio_nfsen', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_percentual_aliquota_relativa_municipio_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                      Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                    </q-tooltip>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Percentual de tributos Simples Nacional"
                    :model-value="opcoes.notasfiscais_percentual_total_tributos_simples_nacional_nfsen"
                    @update:model-value="val => onPercentualInput('notasfiscais_percentual_total_tributos_simples_nacional_nfsen', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen == 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_percentual_total_tributos_simples_nacional_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen == 1">
                      {{ opcoes.notasfiscais_habilitar_nfsen != 1
                        ? 'Disponível apenas quando "Habilitar NFSe Nacional" está marcado.'
                        : 'Disponível apenas quando "Opção Simples Nacional" for diferente de Não Optante.' }}
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Informe apenas um dos dois grupos de percentuais: "Simples Nacional" OU "federais + estaduais + municipais" — nunca os dois ao mesmo tempo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Percentual de tributos federais"
                    :model-value="opcoes.notasfiscais_percentual_total_tributos_federais_nfsen"
                    @update:model-value="val => onPercentualInput('notasfiscais_percentual_total_tributos_federais_nfsen', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_percentual_total_tributos_federais_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1">
                      {{ opcoes.notasfiscais_habilitar_nfsen != 1
                        ? 'Disponível apenas quando "Habilitar NFSe Nacional" está marcado.'
                        : 'Disponível apenas quando "Opção Simples Nacional" = Não Optante.' }}
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Informe apenas um dos dois grupos de percentuais: "Simples Nacional" OU "federais + estaduais + municipais" — nunca os dois ao mesmo tempo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Percentual de tributos estaduais"
                    :model-value="opcoes.notasfiscais_percentual_total_tributos_estaduais_nfsen"
                    @update:model-value="val => onPercentualInput('notasfiscais_percentual_total_tributos_estaduais_nfsen', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_percentual_total_tributos_estaduais_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1">
                      {{ opcoes.notasfiscais_habilitar_nfsen != 1
                        ? 'Disponível apenas quando "Habilitar NFSe Nacional" está marcado.'
                        : 'Disponível apenas quando "Opção Simples Nacional" = Não Optante.' }}
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Informe apenas um dos dois grupos de percentuais: "Simples Nacional" OU "federais + estaduais + municipais" — nunca os dois ao mesmo tempo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <q-input
                    label="Percentual de tributos municipais"
                    :model-value="opcoes.notasfiscais_percentual_total_tributos_municipais_nfsen"
                    @update:model-value="val => onPercentualInput('notasfiscais_percentual_total_tributos_municipais_nfsen', val)"
                    inputmode="decimal"
                    placeholder="0.00"
                    :disable="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1"
                    :class="{ 'field-dirty': isDirty('notasfiscais_percentual_total_tributos_municipais_nfsen') }"
                  >
                    <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1 || opcoes.notasfiscais_codigo_opcao_simples_nacional_nfsen != 1">
                      {{ opcoes.notasfiscais_habilitar_nfsen != 1
                        ? 'Disponível apenas quando "Habilitar NFSe Nacional" está marcado.'
                        : 'Disponível apenas quando "Opção Simples Nacional" = Não Optante.' }}
                    </q-tooltip>
                    <template v-slot:append>
                      <q-icon name="help_outline">
                        <q-tooltip>
                          Informe apenas um dos dois grupos de percentuais: "Simples Nacional" OU "federais + estaduais + municipais" — nunca os dois ao mesmo tempo.
                        </q-tooltip>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
            </div>

            <div class="col-auto gt-sm" style="display: flex;">
              <q-separator vertical />
            </div>

            <div class="col-12 col-md-3 column items-center">
              <div class="column q-gutter-sm">
                <q-checkbox
                  v-model="opcoes.notasfiscais_habilitar_nfsen"
                  label="Habilitar NFSe Nacional"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_habilitar_nfsen') }"
                />
                <q-checkbox
                  v-model="opcoes.notasfiscais_habilitar_localmente_nfsen"
                  label="Modo de Compatibilidade com Abrasf"
                  :disable="opcoes.notasfiscais_habilitar_nfsen != 1"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_habilitar_localmente_nfsen') }"
                >
                  <q-tooltip v-if="opcoes.notasfiscais_habilitar_nfsen != 1">
                    Disponível apenas quando "Habilitar NFSe Nacional" está marcado.
                  </q-tooltip>
                </q-checkbox>
              </div>

              <div class="column q-gutter-sm q-mt-lg">
                <q-checkbox
                  v-model="opcoes.notasfiscais_enviar_nfse_registrada"
                  label="Enviar nota fiscal para o cliente quando registrada"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_enviar_nfse_registrada') }"
                />
                <q-checkbox
                  v-model="opcoes.notasfiscais_registrar_aut_incluida"
                  label="Registrar nota fiscal automaticamente quando incluída"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_registrar_aut_incluida') }"
                />
                <q-checkbox
                  v-model="opcoes.notasfiscais_registrar_aut_cancelada"
                  label="Registrar nota fiscal automaticamente quando cancelada"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_registrar_aut_cancelada') }"
                />
                <q-checkbox
                  v-model="opcoes.notasfiscais_permitir_registro_notas_futuras"
                  label="Permitir o registro de notas futuras"
                  color="green"
                  true-value="1"
                  false-value="0"
                  :class="{ 'field-dirty': isDirty('notasfiscais_permitir_registro_notas_futuras') }"
                />
              </div>

              <div class="certificado-card sticky-upload q-mt-lg">
                <div class="text-caption text-grey-7 q-mb-xs">Certificado Digital</div>

                <q-input
                  label="Senha do Certificado"
                  v-model="opcoes.notasfiscais_passwordcertificado"
                  :type="showSenhaCertificado ? 'text' : 'password'"
                  :error="errors.notasfiscais_passwordcertificado ? true : false"
                  :class="{ 'field-dirty': isDirty('notasfiscais_passwordcertificado') }"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="showSenhaCertificado ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="showSenhaCertificado = !showSenhaCertificado"
                    />
                  </template>
                  <template v-slot:error>
                    <span
                      v-for="(error, i) in errors.notasfiscais_passwordcertificado"
                      :key="error + i"
                    >
                      {{ error }}
                    </span>
                  </template>
                </q-input>

                <label class="custom-file-upload q-mt-sm">
                  <input type="file" style="display: none;" @input="onUpload" />

                  <p id="title">
                    <q-icon name="upload" />
                    Certificado
                  </p>

                  <p v-if="filePath !== ''" style="font-size: 12px">
                    {{ filePath }}
                  </p>
                  <p v-else>Nenhum arquivo selecionado</p>
                </label>

                <div v-if="filePath !== ''" class="q-mt-sm">
                  <div
                    v-if="opcoes.notasfiscais_certificado_validade && !editandoValidadeCertificado"
                    class="row items-center q-gutter-x-xs validade-row"
                  >
                    <q-icon name="fiber_manual_record" :color="certificadoValidadeCor" size="12px" />
                    <span class="text-caption">
                      Válido até {{ $formatDate(opcoes.notasfiscais_certificado_validade) }}
                    </span>
                    <q-space />
                    <q-icon
                      name="edit"
                      size="16px"
                      class="cursor-pointer validade-edit-icon"
                      @click="editandoValidadeCertificado = true"
                    >
                      <q-tooltip>Editar validade</q-tooltip>
                    </q-icon>
                  </div>

                  <q-input
                    v-else
                    label="Informe a validade do certificado"
                    v-model="opcoes.notasfiscais_certificado_validade"
                    type="date"
                    autofocus
                    :class="{ 'field-dirty': isDirty('notasfiscais_certificado_validade') }"
                    @blur="editandoValidadeCertificado = false"
                  />
                </div>
              </div>

              <div class="certificado-card q-mt-md">
                <div class="text-caption text-grey-7 q-mb-xs">Links Úteis</div>
                <div class="column q-gutter-xs text-caption">
                  <a
                    href="https://www.gov.br/nfse/pt-br/biblioteca/documentacao-tecnica/documentacao-atual/anexo_b-nbs2-lista_servico_nacional-snnfse.xlsx/view"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Anexo B – NBS2 / Lista Nacional (gov.br/nfse)</a>
                  <a
                    href="https://dfe-portal.svrs.rs.gov.br/CFF/TabelaIndicadoresDosLocaisDeOperacao"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Tabela de Indicadores da Operação (Portal Conformidade Fácil)</a>
                  <a
                    href="https://dfe-portal.svrs.rs.gov.br/DFE/ClassificacaoTributaria"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Classificação Tributária – CST / cClassTrib (Portal Conformidade Fácil)</a>
                </div>
                <div class="row items-start q-gutter-x-xs q-mt-sm text-caption text-orange-9">
                  <q-icon name="warning" color="orange-9" size="16px" class="q-mt-xs" />
                  <span style="flex: 1;">
                    Esses links são apenas um ponto de partida — confirme com a contabilidade antes de preencher, pois o preenchimento correto pode variar conforme a localidade.
                  </span>
                </div>
              </div>
            </div>

          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right" class="text-primary">
          <div class="q-pa-md">
            <q-btn
              flat
              label="Cancelar"
              class="text-grey-8 q-mr-sm"
              clickable
              @click="cancela()"
            />
            <q-btn
              @click="salvaOpcoes()"
              :loading="loadingSalvaOpcoes"
              label="Salvar"
              color="positive"
            >
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>
          </div>
        </q-card-actions>

      </q-card>
    </q-dialog>

    <q-dialog v-model="mostrarConfirmacaoNotasPendentes" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6">Notas fiscais pendentes de registro</div>
          <div class="q-mt-sm">
            Existem {{ quantidadeNotasPendentes }} nota(s) fiscal(is) ainda sendo registradas. Alterar as configurações agora pode impactar essas notas.
          </div>
        </q-card-section>

        <q-card-section>
          <span>Digite </span><span style="color: #ea4335;">"Compreendo os riscos"</span><span> para confirmar e salvar mesmo assim.</span>
          <q-input
            v-model="textoConfirmacaoRisco"
            autofocus
            class="q-mt-sm"
            @keyup.enter="confirmarSalvarComPendentes()"
          />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn
            flat
            label="Aguardar e voltar mais tarde"
            class="text-grey-8"
            clickable
            @click="fecharConfirmacaoNotasPendentes()"
          />
          <q-btn
            flat
            label="Confirmar e salvar"
            clickable
            :disable="textoConfirmacaoRisco.trim().toLowerCase() !== 'compreendo os riscos'"
            :loading="loadingSalvaOpcoes"
            class="bg-positive text-white"
            @click="confirmarSalvarComPendentes()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { mapGetters } from "vuex";
import { Loading, Dialog } from "quasar";

export default {
  name: "modal-notas-fiscais-opcoes",
  data() {
    return {
      loadingSalvaOpcoes: false,
      uploadingCertificado: false,
      showSenhaCertificado: false,
      editandoValidadeCertificado: false,
      mostrarConfirmacaoNotasPendentes: false,
      quantidadeNotasPendentes: 0,
      textoConfirmacaoRisco: "",
      opcoes: {},
      opcoesOriginais: null,
      opcoesGerarNota: [
        {
          value: 0,
          label: 'Desativado',
        },
        {
          value: 1,
          label: 'Ao criar cobrança',
        },
        {
          value: 2,
          label: 'Ao liquidar cobrança',
        },
      ],
      opcoesAmbiente: [
        {
          value: 1,
          label: 'Produção',
        },
        {
          value: 2,
          label: 'Homologação',
        },
      ],
      opcoesSimNao: [
        { value: '1', label: 'Sim' },
        { value: '2', label: 'Não' },
      ],
      opcoesRegimeEspecialTributacaoAbrasf: [
        { value: '0', label: 'Nenhum' },
        { value: '1', label: 'Microempresa Municipal' },
        { value: '2', label: 'Estimativa' },
        { value: '3', label: 'Sociedade de Profissionais' },
        { value: '4', label: 'Cooperativa' },
        { value: '5', label: 'MEI – Simples Nacional' },
        { value: '6', label: 'ME EPP – Simples Nacional' },
      ],
      opcoesCodigoOpcaoSimplesNacionalNfsen: [
        { value: '1', label: 'Não Optante' },
        { value: '2', label: 'Optante - Microempreendedor Individual (MEI)' },
        { value: '3', label: 'Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)' },
      ],
      opcoesRegimeEspecialTributacaoNfsen: [
        { value: '0', label: 'Nenhum' },
        { value: '1', label: 'Ato Cooperado (Cooperativa)' },
        { value: '2', label: 'Estimativa' },
        { value: '3', label: 'Microempresa Municipal' },
        { value: '4', label: 'Notário ou Registrador' },
        { value: '5', label: 'Profissional Autônomo' },
        { value: '6', label: 'Sociedade de Profissionais' },
      ],
      opcoesRegimeTributarioSimplesNacionalNfsen: [
        { value: '1', label: 'Regime de apuração dos tributos federais e municipal pelo Simples Nacional' },
        { value: '2', label: 'Regime de apuração dos tributos federais pelo SN e ISSQN por fora do SN conforme respectiva legislação municipal do tributo' },
        { value: '3', label: 'Regime de apuração dos tributos federais e municipal por fora do SN conforme respectivas legislações federal e municipal de cada tributo' },
      ],
      opcoesTipoRetencaoIssNfsen: [
        { value: '1', label: 'Não Retido' },
        { value: '2', label: 'Retido pelo Tomador' },
        { value: '3', label: 'Retido pelo Intermediário' },
      ],
      opcoesTributacaoIssNfsen: [
        { value: '1', label: 'Operação tributável' },
        { value: '2', label: 'Imunidade' },
        { value: '3', label: 'Exportação de serviço' },
        { value: '4', label: 'Não Incidência' },
      ],
      // Mesmos códigos usados tanto no Abrasf (EmissaoService::registrarNfseAbrasf) quanto
      // na NFSe Nacional (registrarNfsen) — não há variante "_nfsen" separada para esses 3.
      opcoesFinalidadeEmissao: [
        { value: '0', label: 'NFS-e Regular' },
      ],
      opcoesIndicadorDestinatario: [
        { value: '0', label: 'Tomador é o próprio destinatário' },
        { value: '1', label: 'Destinatário é outra pessoa' },
      ],
      opcoesConsumidorFinalReforma: [
        { value: '0', label: 'Não' },
        { value: '1', label: 'Sim' },
      ],
      errors: [],
    };
  },
  methods: {
    isDirty(campo) {
      if (!this.opcoesOriginais) return false;
      return String(this.opcoes[campo] ?? "") !== String(this.opcoesOriginais[campo] ?? "");
    },
    onPercentualInput(campo, valor) {
      let v = String(valor ?? "").replace(",", ".").replace(/[^\d.]/g, "");
      const partes = v.split(".");
      if (partes.length > 2) {
        v = partes[0] + "." + partes.slice(1).join("");
      }
      this.opcoes[campo] = v;
    },
    cancela() {
      if (this.temAlteracoesPendentes) {
        Dialog.create({
          title: "Alterações não salvas",
          message: "Você tem alterações que ainda não foram salvas. Deseja realmente sair sem salvar?",
          ok: { label: "Sair sem salvar", color: "negative", flat: true },
          cancel: { label: "Continuar editando", flat: true },
          persistent: true,
        }).onOk(() => {
          this.fecharModal();
        });
        return;
      }

      this.fecharModal();
    },
    fecharModal() {
      this.errors = [];
      this.$store.commit("openDialogOpcoesNotaFiscal", false);
    },
    fecharConfirmacaoNotasPendentes() {
      this.mostrarConfirmacaoNotasPendentes = false;
      this.textoConfirmacaoRisco = "";
    },
    confirmarSalvarComPendentes() {
      if (this.textoConfirmacaoRisco.trim().toLowerCase() !== "compreendo os riscos") return;

      this.opcoes.notasfiscais_confirmar_alteracao_com_pendentes = true;
      this.mostrarConfirmacaoNotasPendentes = false;
      this.textoConfirmacaoRisco = "";
      this.salvaOpcoes();
    },
    salvaOpcoes() {
      this.loadingSalvaOpcoes = true;

      axios.post('notas-fiscais/opcoes', this.opcoes)
        .then(res => {
          this.loadingSalvaOpcoes = false;

          if (!res.data.success) {
            if (res.data.atualizar_rps) {
              this.opcoes.notasfiscais_ultimorps = res.data.atualizar_rps;
            }

            if (res.data.errors) {
              this.errors = res.data.errors;
            }

            if (res.data.alertaNotasPendentes) {
              this.quantidadeNotasPendentes = res.data.quantidadeRegistrando;
              this.mostrarConfirmacaoNotasPendentes = true;
              return;
            }

            if (res.data.errorFocus) {
              Dialog.create({
                title: "Erro",
                message: res.data.message,
                class: "bg-negative text-white",
                ok: {
                  "text-color": "red",
                  color: "white"
                }
              });
            } else {
              this.$q.notify({
                message: res.data.message,
                color: "orange",
                position: "top-right",
              });
            }

            return;
          }

          this.$q.notify({
            message: "Sucesso ao salvar as opções",
            color: "green",
            position: "top-right",
          });

          this.$store.commit("opcoesNotaFiscal", res.data.opcoes);

          // Acabamos de salvar com sucesso — não há alteração pendente para perguntar
          // sobre. Chamar cancela() aqui reabriria essa pergunta incorretamente: o watch
          // de opcoesNotaFiscal (que reseta opcoesOriginais) só roda no próximo tick, então
          // temAlteracoesPendentes ainda compararia contra o snapshot antigo.
          this.fecharModal();
        })
        .catch(() => {
          this.$q.notify({
            message: "Houve um erro ao salvar as opções",
            color: "red",
            position: "top-right",
          });
          this.loadingSalvaOpcoes = false;
        });
    },
    onUpload(event) {
      if (this.uploadingCertificado) return;

      event.preventDefault();
      const file = event.target.files[0];
      // Limpa o input agora: garante que selecionar o mesmo arquivo de novo
      // (ex.: reenviar o mesmo certificado) ainda dispare o evento @input.
      event.target.value = "";

      if (!file) {
        this.$q.notify({
          message: "Nenhum arquivo selecionado",
          color: "orange",
          position: "top-right",
        });
        return;
      }

      this.uploadingCertificado = true;
      Loading.show();
      const fd = new FormData();
      fd.append("file", file);
      // Envia a senha já digitada (mesmo que ainda não salva) para o backend
      // tentar identificar a validade do certificado automaticamente.
      fd.append("notasfiscais_passwordcertificado", this.opcoes.notasfiscais_passwordcertificado || "");

      axios
        .post("notas-fiscais/opcoes?upload_certificado=1", fd, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(res => {
          this.uploadingCertificado = false;
          Loading.hide();

          if (!res.data.success) {
            this.$q.notify({
              message: res.data.message,
              color: "orange",
              position: "top-right",
            });
            return;
          }

          // Reflete o estado canônico do backend (path novo + certificado_sync="0").
          // O watch de opcoesNotaFiscal atualiza this.opcoes em seguida.
          if (res.data.opcoes) {
            this.$store.commit("opcoesNotaFiscal", res.data.opcoes);
          } else {
            // Fallback de compat: backend antigo só retornava path.
            this.opcoes["notasfiscais_pathcertificado"] = res.data.path;
          }

          this.$q.notify({
            message: res.data.message,
            color: "green",
            position: "top-right",
          });
        })
        .catch(() => {
          this.uploadingCertificado = false;
          Loading.hide();
          this.$q.notify({
            message: "Houve um erro ao enviar o certificado",
            color: "red",
            position: "top-right",
          });
        });
    }
  },
  computed: {
    ...mapGetters([
      "openDialogOpcoesNotaFiscal",
      "opcoesNotaFiscal",
      "homologadosNotaFiscal"
    ]),
    filePath() {
      if (!this.opcoes["notasfiscais_pathcertificado"]) return '';
      const path = this.opcoes["notasfiscais_pathcertificado"].split(/[\\/]/);
      return path[path.length - 1];
    },
    certificadoValidadeCor() {
      const raw = this.opcoes.notasfiscais_certificado_validade;
      if (!raw) return "grey-5";

      const validade = new Date(raw + "T00:00:00");
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const diffDias = (validade - hoje) / 86400000;

      if (diffDias < 0) return "red";
      if (diffDias <= 30) return "orange";
      return "green";
    },
    temAlteracoesPendentes() {
      if (!this.opcoesOriginais) return false;
      return JSON.stringify(this.opcoes) !== JSON.stringify(this.opcoesOriginais);
    }
  },
  watch: {
    opcoesNotaFiscal (val) {
      this.opcoes = val;
      if (this.opcoesGerarNota[val.notasfiscais_gerar_nfse]) {
        this.opcoes.notasfiscais_gerar_nfse = this.opcoesGerarNota[val.notasfiscais_gerar_nfse].value;
      }
      if (this.opcoesAmbiente[val.notasfiscais_homologacao - 1]) {
        this.opcoes.notasfiscais_homologacao = this.opcoesAmbiente[val.notasfiscais_homologacao - 1].value;
      }
      this.opcoesOriginais = JSON.parse(JSON.stringify(this.opcoes));
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 12px 0px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  transition: all 0.3s;
}

.custom-file-upload:hover {
  background-color: #eee;
}

.sticky-upload {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 1;
}

.certificado-card {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 12px;
}

.validade-edit-icon {
  opacity: 0;
  transition: opacity 0.2s;
}

.validade-row:hover .validade-edit-icon {
  opacity: 1;
}

.field-dirty {
  background-color: rgba(255, 213, 79, 0.35);
  border-radius: 4px;
  transition: background-color 0.2s;
}

.custom-file-upload p#title {
  font-size: 16px;
  color: rgba(0,0,0,0.6);
}

.custom-file-upload p {
  margin: 0;
}
</style>
